import moment from 'moment';

export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE'
};

export const AppProfile = {
  excludeMenuKey: ['F2B811E1-B50B-4ABC-B078-9E0B1BECC238', 'B07E5C91-4D70-4B99-AC80-276419735CEB'],
  userConfigMenuKey: 'F2B811E1-B50B-4ABC-B078-9E0B1BECC238',
  errorLogMenuKey: 'B07E5C91-4D70-4B99-AC80-276419735CEB',
};
export const ReportMasterKeys = {
  invoiceReportKey: '1C6FD6CC-395F-4240-B7F9-00F6445E1D51',
  transactionReportKey: '29E32F9E-D09C-45F5-83EB-914508A68FB6',
  MISReportKey: '677505D7-E0FA-45E3-9E90-D2A4FE373E60',
  auditReportKey: '6FC1AE56-ECD1-4788-AD56-901B5163D5D4',
};

export const transform = (originalValue : string) => {
  if (String(new Date(originalValue).getFullYear()).length <= 3) {
    return 'invalid date';
  }
  if (originalValue) {
    return new Date(moment(originalValue, 'dd/MM/YYYY HH:mm:ss').toDate());
  }
  return originalValue;
};

export const splitDataIntoList = (originalValue: string) => {
  let stringsList = [];
  if (!originalValue.includes(',')) {
    stringsList.push(originalValue);
  } else {
    stringsList.push(originalValue.split(','));
  }
  return stringsList.flat();
};

export const dateFormat = (date : Date | string, format = 'DD/MM/YYYY HH:mm:ss') => {
  return moment(date).format(format);
};

export const dateTransformer = (data: any): any => {
  if (data instanceof Date) {
    // do your specific formatting here
    return dateFormat(data, 'YYYY-MM-DDTHH:mm:ssZ');
  }
  if (Array.isArray(data)) {
    return data.map(dateTransformer);
  }
  if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, dateTransformer(value)]));
  }
  return data;
};

export const numberFormat = (value : bigint | number) => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR'
}).format(value);

export const accountNameArr = [1, 13, 37]; // Category ID (NCES, NCEW1 , NCEW2)

export const fileInfoSize = (size : number) => {
  if (size > 100000) {
    return true;
  }
  return false;
};
